"use strict";

var _taggedTemplateLiteral = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: normal;\n  min-height: calc(", " * ", " / 6);\n\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: bold;\n  padding-bottom: 0.375em;\n\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  white-space: pre-wrap;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: 7.5%;\n\n  color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n\n  width: calc(", " * ", ");\n  height: calc(", " * ", ");\n  background-color: var(--color-grey-dark-1);\n\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  ", "\n  border: 1px solid var(--color-grey-light-2);\n  box-shadow: var(--box-shadow-node);\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: calc(", " * ", ");\n  border-radius: 0.375em;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  border-radius: 0.375em;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

exports.DEFAULT_SIZE = '25rem';
exports.imageExpOptionShapeStyle = styled_components_1.css(_templateObject(), exports.DEFAULT_SIZE);

exports.initImageExpOptionShapeStyle = function (scale) {
  return styled_components_1.css(_templateObject2(), exports.DEFAULT_SIZE, Math.pow(scale, scale));
};

exports.StyledImageExpOptionWrapperDiv = styled_components_1.default.div(_templateObject3(), function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (props) {
  return exports.initImageExpOptionShapeStyle(props.theme.scale);
});
exports.StyledImageExpOptionImageDiv = styled_components_1.default.div(_templateObject4(), exports.DEFAULT_SIZE, function (_ref2) {
  var scale = _ref2.theme.scale;
  return Math.pow(scale, scale);
}, exports.DEFAULT_SIZE, function (_ref3) {
  var scale = _ref3.theme.scale;
  return Math.pow(scale, scale);
}, function (_ref4) {
  var imageUrl = _ref4.imageUrl;
  return imageUrl && "url(\"".concat(imageUrl, "\")");
});
exports.StyledImageExpOptionBodyDiv = styled_components_1.default.div(_templateObject5(), function (_ref5) {
  var color = _ref5.color;
  return color;
});
exports.StyledImageNameH2 = styled_components_1.default.h2(_templateObject6(), function (props) {
  return props.theme.fontSize.default + 'rem';
});
exports.StyledExplanationDiv = styled_components_1.default.div(_templateObject7(), function (props) {
  return props.theme.fontSize.medium + 'rem';
}, exports.DEFAULT_SIZE, function (props) {
  return props.theme.scale;
});